export const renderAnswerValue = ({ value }) => {
  if (value.notApplicable) {
    return 'N/A'
  }
  switch (value.type) {
    case 'bool':
      return value['bool'] ? 'Sim' : 'Não'
    case 'number':
      return value['number']
    case 'options':
      return value['options'].map(({ value }) => value).join(', ')
    default:
      return 'Unknown'
  }
}

export default renderAnswerValue
